































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import states from "@/assets/dictionaries/state-list.ts";
declare module "@/assets/dictionaries/state-list.ts";

interface FormFields {
    firstName: string;
    MI: string;
    lastName: string;
    title: string;
    company: string;
    city: string;
    state: string;
    phone: string;
    email: string;
    lookingNetwork: boolean;
    lookingCollab: boolean;
    lookingHiring: boolean;
    lookingTech: boolean;
    lookingResearch: boolean;
    lookingLeadership: boolean;
    lookingEmployment: boolean;
    imgPath: string;
    status: string;
    biography: string;
    instagramURL: string;
    facebookURL: string;
    linkedInURL: string;
    favoriteSessions: Array<string>;
}
@Component({})
export default class CreateAttendee extends Vue {
    apiResponse = {
        status: 0,
        message: "",
    };
    states = states;

    formFields: FormFields = {
        firstName: "",
        MI: "",
        lastName: "",
        title: "",
        company: "",
        city: "",
        state: "",
        phone: "",
        email: "",
        lookingNetwork: false,
        lookingCollab: false,
        lookingHiring: false,
        lookingTech: false,
        lookingResearch: false,
        lookingLeadership: false,
        lookingEmployment: false,
        imgPath: "",
        status: "",
        biography: "",
        instagramURL: "",
        facebookURL: "",
        linkedInURL: "",
        favoriteSessions: [],
    };

    get fullName() {
        // TODO: If we have both first and last name search fields, it should also be separate fields in the database
        return [this.formFields.firstName, this.formFields.lastName]
            .filter((name) => name)
            .join(" AND ");
    }

    submitForm(): void {
        console.log(this.formFields);
        axios
            .post(
                "https://vmp-back.azurewebsites.net/api/CreateAttendee",
                this.formFields
            )
            .then((response) => {
                this.apiResponse.status = response.status;
                if (this.apiResponse.status === 200) {
                    alert("Profile submitted.");
                    this.clearForm();
                }
            })
            .catch((error) => {
                this.apiResponse.status = error.response.status;
                this.apiResponse.message = error.response.data;
                alert("Error submitting profile.");
            });
    }

    clearForm() {
        this.formFields = {
            firstName: "",
            MI: "",
            lastName: "",
            title: "",
            company: "",
            city: "",
            state: "",
            phone: "",
            email: "",
            lookingNetwork: false,
            lookingCollab: false,
            lookingHiring: false,
            lookingTech: false,
            lookingResearch: false,
            lookingLeadership: false,
            lookingEmployment: false,
            imgPath: "",
            status: "",
            biography: "",
            instagramURL: "",
            facebookURL: "",
            linkedInURL: "",
            favoriteSessions: [],
        };
    }
}
